import Sticky from './Sticky';

export default () => {
  const sticky = new Sticky();

  sticky.init();

  return sticky;
};
